













import {
  defineComponent,
} from '@vue/composition-api'
import PageSection from '@/components/layouts/PageSection.vue'
import ClientContactDetails from './pods/ClientContactDetails.vue'
// import WelcomeMessageStatus from './pods/WelcomeMessageStatus.vue'

export default defineComponent({
  components: {
    ClientContactDetails, PageSection, // WelcomeMessageStatus,
  },

  props: {
    clientId: { type: String, default: '' },
  },

})

